import { connect } from 'react-redux';

import LoginForm from 'components/auth/LoginForm';
import { login } from 'actions/auth';

export default connect(null, {
  login,
})(LoginForm);
